import Image from 'next/image';

export function FreeformImage({ file: { url, size }, caption }) {
  return <Image alt={caption || ''} src={url} style={{ borderRadius: '6px' }} width={size.width} height={size.height} />;
}
